import { Alert, SearchInput } from "@dealer-center/core-components";
import { usePermissionGroupsGet } from "@dealer-center/ddc-pages-user-permissions-manager-fetch";
import styled from "styled-components";
import { formatPermissionOptions } from "./helper";
import { LoadingIndicator } from "@dealer-center/core-custom-components";
import { useEffect, useState } from "react";
import PermissionsToAdd from "./PermissionsToAdd";

const StyledAddPermission = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  gap: 1rem;
  margin-bottom: 1rem;
`;

const StyledPermissionsList = styled.div`
  width: 100%;
  border: none;
  max-height: 30rem;
  overflow: auto;
`;

const StyledLoadingIndicator = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

interface PermissionsSearchBarProps {
  onPermissionsChange: (permissions: string[]) => void;
}

export function PermissionsSearchBar({
  onPermissionsChange
}: PermissionsSearchBarProps) {
  const { data, error, isLoading } = usePermissionGroupsGet();
  const [inputList, setInputList] = useState<string[]>([]);
  const [inputValue, setInputValue] = useState<string>("");

  useEffect(() => {
    if (inputValue && !inputList.includes(inputValue)) {
      const newList = [...inputList, inputValue];
      setInputList(prevList => [...prevList, inputValue]);
      onPermissionsChange(newList);
      setInputValue("");
    }
  }, [inputValue, inputList, onPermissionsChange]);

  const removePermission = (permission: string) => {
    const newList = inputList.filter(item => item !== permission);
    setInputList(newList);
    onPermissionsChange(newList);
  };

  if (error) {
    return (
      <Alert role="alert" sx={{ marginBottom: "16px" }} type="error">
        {error.message}
      </Alert>
    );
  }

  if (isLoading)
    return (
      <StyledLoadingIndicator>
        <LoadingIndicator
          actionName="Loading PermissionsSearchBar"
          text="Loading"
        />
      </StyledLoadingIndicator>
    );

  const permissionOptions = formatPermissionOptions(data);

  return (
    <StyledAddPermission>
      <SearchInput
        aria-label="search input"
        buttonAriaLabel="search button input label"
        id="search-input-id"
        name="search-input-default"
        options={permissionOptions}
        placeholder="Search By Permission"
        size="small"
        onChange={e => {
          if (e.target && e.target.value && e.target.value.id) {
            setInputValue(e.target.value.id);
          }
        }}
        onClearCallback={() => {
          setInputValue("");
          setInputList([]);
        }}
      />
      <StyledPermissionsList>
        {inputList.length > 0 && (
          <PermissionsToAdd
            permissions={inputList}
            onRemove={removePermission}
          />
        )}
      </StyledPermissionsList>
    </StyledAddPermission>
  );
}
